import { render, staticRenderFns } from "./ClientSafetyPlan.vue?vue&type=template&id=704a0eed"
import script from "./ClientSafetyPlan.vue?vue&type=script&lang=js"
export * from "./ClientSafetyPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports